export const name = "JUSTIFY_HOURS";
export const summary = `Normalizes the time part of an \`INTERVAL\` value.`;
export const reference = `
## JUSTIFY_HOURS

Normalizes the time part of an \`INTERVAL\` value.

\`\`\`
JUSTIFY_HOURS(interval_expression)
\`\`\`

### Description

Normalizes the time part of the interval to the range from -23:59:59.999999 to 23:59:59.999999 by incrementing/decrementing the day part of the interval.


### Return Data Type

\`INTERVAL\`


### Example



\`\`\`
SELECT
  JUSTIFY_HOURS(INTERVAL 23 HOUR) AS i1,
  JUSTIFY_HOURS(INTERVAL -24 HOUR) AS i2,
  JUSTIFY_HOURS(INTERVAL 47 HOUR) AS i3,
  JUSTIFY_HOURS(INTERVAL -12345 MINUTE) AS i4

/*--------------+--------------+--------------+-----------------*
 | i1 | i2 | i3 | i4 |
 +--------------+--------------+--------------+-----------------+
 | 0-0 0 23:0:0 | 0-0 -1 0:0:0 | 0-0 1 23:0:0 | 0-0 -8 -13:45:0 |
 *--------------+--------------+--------------+-----------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/interval_functions
`;
